import React, {useEffect} from 'react'
import { Page, Text, Document, StyleSheet, Image } from '@react-pdf/renderer';

export default function PdfInvoicesWeek(props) {

    useEffect(() => {
        console.log(props.lundi)
    }, [props.lundi]);

    const styles = StyleSheet.create({
        page: {
            flexDirection: 'column',
            backgroundColor: '#FFFFFF',
            width: "100%",
            padding: 10
        },
        part: {
            flexDirection: 'column',
            marginTop: 10,
            alignItems: "center"
        },
        text: {
            flexDirection: 'column',
            fontSize: 10,
        },
        title: {
            fontSize: 12,
        },
        Day: {
            fontSize: 10,
            textDecoration: "underline"
        },
        week: {
            flexDirection: 'row',
        }
    })

    function content(value) {
        if (value !== '') {
            return 1;
        } else {
            return 0;
        }      
    }

    const LundiMenu = props.lundi.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Lundi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const MardiMenu = props.mardi.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Mardi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const MercrediMenu = props.mercredi.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Mercredi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const JeudiMenu = props.jeudi.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Jeudi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const VendrediMenu = props.vendredi.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Vendredi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const SamediMenu = props.samedi.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Samedi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const DimancheMenu = props.dimanche.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Dimanche</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    // SECOND WEEK

    const LundiMenu2 = props.lundi2.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Lundi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const MardiMenu2 = props.mardi2.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Mardi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const MercrediMenu2 = props.mercredi2.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Mercredi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const JeudiMenu2 = props.jeudi2.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Jeudi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const VendrediMenu2 = props.vendredi2.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Vendredi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const SamediMenu2 = props.samedi2.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Samedi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const DimancheMenu2 = props.dimanche2.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Dimanche</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    // THIRD WEEK

    const LundiMenu3 = props.lundi3.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Lundi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const MardiMenu3 = props.mardi3.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Mardi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const MercrediMenu3 = props.mercredi3.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Mercredi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const JeudiMenu3 = props.jeudi3.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Jeudi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const VendrediMenu3 = props.vendredi3.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Vendredi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const SamediMenu3 = props.samedi3.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Samedi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const DimancheMenu3 = props.dimanche3.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Dimanche</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    // FOURTH WEEK

    const LundiMenu4 = props.lundi4.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Lundi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const MardiMenu4 = props.mardi4.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Mardi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const MercrediMenu4 = props.mercredi4.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Mercredi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const JeudiMenu4 = props.jeudi4.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Jeudi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const VendrediMenu4 = props.vendredi4.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Vendredi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const SamediMenu4 = props.samedi4.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Samedi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const DimancheMenu4 = props.dimanche4.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Dimanche</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    // FIFTH WEEK

    const LundiMenu5 = props.lundi5.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Lundi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const MardiMenu5 = props.mardi5.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Mardi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const MercrediMenu5 = props.mercredi5.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Mercredi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const JeudiMenu5 = props.jeudi5.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Jeudi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const VendrediMenu5 = props.vendredi5.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Vendredi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const SamediMenu5 = props.samedi5.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Samedi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const DimancheMenu5 = props.dimanche5.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Dimanche</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    // SIX WEEK

    const LundiMenu6 = props.lundi6.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Lundi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const MardiMenu6 = props.mardi6.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Mardi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const MercrediMenu6 = props.mercredi6.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Mercredi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const JeudiMenu6 = props.jeudi6.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Jeudi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const VendrediMenu6 = props.vendredi6.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Vendredi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const SamediMenu6 = props.samedi6.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Samedi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    const DimancheMenu6 = props.dimanche6.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Dimanche</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>Plat: {content(d.plat)}</Text><br/>
        <Text style={styles.text}>Potage: {d.potage ? 1 : 0}</Text><br/>
        <Text style={styles.text}>Diner: {content(d.diner)}</Text><br/>
    </view>);

    return (
        <Document title="RecapMenu.pdf">
            <Page style={styles.page} size="A4" orientation='portrait'>
                <Image src="/logo.png" style={{width: '10vh', alignSelf: "center"}}/>
                <Text style={styles.title}>Nom : {props.client}</Text>
                <view style={styles.week}>
                    <view wrap={false} style={styles.part}>{LundiMenu}</view>
                    <view wrap={false} style={styles.part}>{MardiMenu}</view>
                    <view wrap={false} style={styles.part}>{MercrediMenu}</view>
                    <view wrap={false} style={styles.part}>{JeudiMenu}</view>
                    <view wrap={false} style={styles.part}>{VendrediMenu}</view>
                    <view wrap={false} style={styles.part}>{SamediMenu}</view>
                    <view wrap={false} style={styles.part}>{DimancheMenu}</view>
                </view>

                <view style={styles.week}>
                    <view wrap={false} style={styles.part}>{LundiMenu2}</view>
                    <view wrap={false} style={styles.part}>{MardiMenu2}</view>
                    <view wrap={false} style={styles.part}>{MercrediMenu2}</view>
                    <view wrap={false} style={styles.part}>{JeudiMenu2}</view>
                    <view wrap={false} style={styles.part}>{VendrediMenu2}</view>
                    <view wrap={false} style={styles.part}>{SamediMenu2}</view>
                    <view wrap={false} style={styles.part}>{DimancheMenu2}</view>
                </view>

                <view style={styles.week}>
                    <view wrap={false} style={styles.part}>{LundiMenu3}</view>
                    <view wrap={false} style={styles.part}>{MardiMenu3}</view>
                    <view wrap={false} style={styles.part}>{MercrediMenu3}</view>
                    <view wrap={false} style={styles.part}>{JeudiMenu3}</view>
                    <view wrap={false} style={styles.part}>{VendrediMenu3}</view>
                    <view wrap={false} style={styles.part}>{SamediMenu3}</view>
                    <view wrap={false} style={styles.part}>{DimancheMenu3}</view>
                </view>

                <view style={styles.week}>
                    <view wrap={false} style={styles.part}>{LundiMenu4}</view>
                    <view wrap={false} style={styles.part}>{MardiMenu4}</view>
                    <view wrap={false} style={styles.part}>{MercrediMenu4}</view>
                    <view wrap={false} style={styles.part}>{JeudiMenu4}</view>
                    <view wrap={false} style={styles.part}>{VendrediMenu4}</view>
                    <view wrap={false} style={styles.part}>{SamediMenu4}</view>
                    <view wrap={false} style={styles.part}>{DimancheMenu4}</view>
                </view>

                <view style={styles.week}>
                    <view wrap={false} style={styles.part}>{LundiMenu5}</view>
                    <view wrap={false} style={styles.part}>{MardiMenu5}</view>
                    <view wrap={false} style={styles.part}>{MercrediMenu5}</view>
                    <view wrap={false} style={styles.part}>{JeudiMenu5}</view>
                    <view wrap={false} style={styles.part}>{VendrediMenu5}</view>
                    <view wrap={false} style={styles.part}>{SamediMenu5}</view>
                    <view wrap={false} style={styles.part}>{DimancheMenu5}</view>
                </view>

                <view style={styles.week}>
                    <view wrap={false} style={styles.part}>{LundiMenu6}</view>
                    <view wrap={false} style={styles.part}>{MardiMenu6}</view>
                    <view wrap={false} style={styles.part}>{MercrediMenu6}</view>
                    <view wrap={false} style={styles.part}>{JeudiMenu6}</view>
                    <view wrap={false} style={styles.part}>{VendrediMenu6}</view>
                    <view wrap={false} style={styles.part}>{SamediMenu6}</view>
                    <view wrap={false} style={styles.part}>{DimancheMenu6}</view>
                </view>

            </Page>
        </Document>
    )
}